// Labels extracted to @heidi/agents/data tool-registry — history: git log --follow src/features/projects/timeline/toolPresentation.ts
import { cn } from '@heidi/utils';
import {
  BarChart3,
  CalendarClock,
  CalendarDays,
  CalendarSearch,
  FileSpreadsheet,
  FileText,
  Flag,
  FolderMinus,
  FolderOpen,
  FolderPen,
  FolderPlus,
  FolderSearch,
  Hash,
  Layers,
  Link2,
  ListChecks,
  Mail,
  Merge,
  Mic,
  Pin,
  PinOff,
  Presentation,
  RotateCcw,
  Search,
  Share2,
  Trash2,
  Unlink,
  UserRound,
  UserRoundMinus,
  UserRoundPlus,
  UsersRound,
  X,
  Zap,
  type LucideIcon,
  type LucideProps,
} from 'lucide-react';
import { createElement, forwardRef } from 'react';

import {
  TOOL_PRESENTATION_REGISTRY,
  type ToolIconName,
} from '../../../data/projects/timeline/presentation/tool-registry';

const SessionMergeIcon = forwardRef<SVGSVGElement, LucideProps>(function SessionMergeIcon(
  { className, ...props },
  ref
) {
  return createElement(Merge, {
    ref,
    className: cn('rotate-90', className),
    ...props,
  });
}) as LucideIcon;

const TOOL_ICONS: Record<ToolIconName, LucideIcon> = {
  'bar-chart-3': BarChart3,
  'calendar-clock': CalendarClock,
  'calendar-days': CalendarDays,
  'calendar-search': CalendarSearch,
  'file-spreadsheet': FileSpreadsheet,
  'file-text': FileText,
  flag: Flag,
  'folder-minus': FolderMinus,
  'folder-open': FolderOpen,
  'folder-pen': FolderPen,
  'folder-plus': FolderPlus,
  'folder-search': FolderSearch,
  hash: Hash,
  'link-2': Link2,
  'list-checks': ListChecks,
  mail: Mail,
  mic: Mic,
  pin: Pin,
  'pin-off': PinOff,
  presentation: Presentation,
  'rotate-ccw': RotateCcw,
  search: Search,
  'session-merge': SessionMergeIcon,
  'share-2': Share2,
  'trash-2': Trash2,
  unlink: Unlink,
  'user-round': UserRound,
  'user-round-minus': UserRoundMinus,
  'user-round-plus': UserRoundPlus,
  'users-round': UsersRound,
  x: X,
  zap: Zap,
};

/**
 * Lucide icon for an inline or grouped tool-use row. Tools without a registry
 * label (or whose icon name is unknown) fall back to `Layers`.
 */
export const toolIcon = (toolName: string): LucideIcon => {
  const iconName = TOOL_PRESENTATION_REGISTRY[toolName]?.label?.icon;
  return (iconName !== undefined ? TOOL_ICONS[iconName] : undefined) ?? Layers;
};
